import { Box, Typography } from '@mui/material';

interface QualificationFormHeaderProps {
  title: string;
  description?: string;
}
const QualificationFormHeader: React.FC<QualificationFormHeaderProps> = ({ title, description }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6">{title}</Typography>
      {description && (
        <Typography paragraph sx={{ mb: 0 }} color="secondary" variant="medium" fontWeight="Medium">
          {description}
        </Typography>
      )}
    </Box>
  );
};

export const FindQualificationHeader: React.FC = () => {
  return (
    <QualificationFormHeader
      title="Find your eligibility qualification you have submitted before"
      description="This would help us to find your eligibility qualification and find eligible programs, institutions and scholarships for you."
    />
  );
};

export const ShareQualificationHeader: React.FC = () => {
  return (
    <QualificationFormHeader
      title="Share us your eligibility qualification"
      description="Please provide full information about your eligibility qualification. This would help you to find eligible programs, institutions and scholarships for you."
    />
  );
};

export const FillPersonalQualificationHeader: React.FC = () => {
  return (
    <QualificationFormHeader
      title="Fill in your personal information"
      description="Please provide full information about your eligibility qualification. This would help you to find eligible programs, institutions and scholarships for you."
    />
  );
};

export const SelectQualificationHeader: React.FC = () => {
  return <QualificationFormHeader title="Select your eligibility qualification and find eligible programs" />;
};
